import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Palette, Search, Warehouse, Star, Video, ArrowRight } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  Truck: Truck,
  Palette: Palette,
  Search: Search,
  Warehouse: Warehouse,
  Star: Star,
  Video: Video
};

const Services = ({ showAll = false }) => {
  const displayServices = showAll ? services : services.slice(0, 6);

  return (
    <section className="py-24 bg-gray-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Modern Section Header - Left Aligned */}
        <div className="mb-16">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-1 h-8 bg-gradient-to-b from-orange-500 to-amber-500"></div>
            <span className="text-orange-600 font-bold text-sm uppercase tracking-widest">What We Offer</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            End-to-End
            <span className="block bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">Fulfillment Solutions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl leading-relaxed">
            Everything you need to scale your ecommerce business
          </p>
        </div>

        {/* Modern Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayServices.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <div
                key={service.id}
                className="group relative bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-orange-200"
              >
                {/* Modern Icon */}
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent size={28} className="text-white" />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Modern Link */}
                <Link
                  to="/services"
                  className="inline-flex items-center text-orange-600 font-bold hover:text-orange-700 group-hover:gap-2 transition-all duration-300"
                >
                  <span>Learn More</span>
                  <ArrowRight size={18} className="ml-1 group-hover:translate-x-1 transition-transform" />
                </Link>

                {/* Number Badge */}
                <div className="absolute top-8 right-8 w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center">
                  <span className="text-orange-600 font-bold text-sm">{index + 1}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Modern CTA */}
        {!showAll && (
          <div className="text-center mt-16">
            <Link
              to="/services"
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-10 py-5 rounded-xl font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all duration-300"
            >
              <span>View All Services</span>
              <ArrowRight size={24} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;